import React from 'react'
import PropTypes from 'prop-types'
import qrImage from 'qr-image'

const QRCode = ({ data, color, styles }) => {
  const result = qrImage.svgObject(data)

  const viewBox = `0 0 ${result.size} ${result.size}`

  return (
    <svg className="rrttt" style={styles} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <path d={result.path} style={{ fill: color }} />
    </svg>
  )
}

QRCode.defaultProps = {
  data: 'error',
  color: '#000000',
  styles: {},
}

QRCode.propTypes = {
  data: PropTypes.string,
  color: PropTypes.string,
  styles: PropTypes.object,
}

export default QRCode
